import React from 'react';
import { style } from 'typestyle';
import { type MdiReactIconComponentType } from 'mdi-react';
import * as styles from './primary-button.styles';
import { Center } from '../center/center.component';
import ActivityIndicator from '../activity-indicator/activity-indicator.component';
import StyleConstants from '../../styles.constants';
import mergeClasses from '../../utils/merge-classes';
import AppConstants from '../../app.constants';

interface Props {
  readonly className?: string;
  readonly children: string;
  readonly loading?: boolean;
  readonly fullWidth?: boolean;
  readonly disabled?: boolean;
  readonly icon?: MdiReactIconComponentType;
  readonly onClick?: () => void;
  readonly showTooltip?: boolean;
  readonly tooltipText?: string;
}

const PrimaryButton = ({
  className,
  children,
  loading,
  fullWidth,
  disabled,
  icon,
  onClick,
  showTooltip,
  tooltipText,
}: Props): React.JSX.Element => {
  const Icon = icon;
  return (
    <div>
      <div
        data-tooltip-id={showTooltip === true ? AppConstants.TOOLTIP_GENERAL_ID : undefined}
        data-tooltip-content={showTooltip === true ? tooltipText : undefined}
        className={mergeClasses(className, style(styles.primaryButton(loading, fullWidth, disabled)))}
        onClick={!disabled ? onClick : undefined}
        role="presentation"
      >
        <Center>{loading ? <ActivityIndicator size={12} color={StyleConstants.GREY_COLOR} /> : children}</Center>
        {Icon != null && <Icon className={style(styles.icon)} />}
      </div>
    </div>
  );
};

export default PrimaryButton;
